import { Accordion } from "@/components/ui/accordion";
import React from "react";
import { useLocale, useTranslations } from "../../../helpers/translations";
import { generateLocalizedPath } from "../helpers/links";
import { MARKETING_ROUTES, RAILS_ROUTES } from "../helpers/routes";
import { MobileNavSubSection } from "../shared/MobileNavSubSection";
import { NavSubMenuSection } from "../shared/NavSubMenuSection";

type CompanySubMenuProps = {
  compact?: boolean;
  wrapperComponent: React.ComponentType<{
    title: string;
    children: React.ReactNode;
  }>;
};

export const CompanySubMenu = ({
  wrapperComponent,
  compact,
}: CompanySubMenuProps) => {
  const t = useTranslations("nav.community");
  const locale = useLocale();
  const WrapperComponent = wrapperComponent;

  if (!compact) {
    return (
      <WrapperComponent title={t("title")}>
        <NavSubMenuSection
          heading={t("vention.header")}
          items={[
            {
              title: t("vention.links.mission.title"),
              href: generateLocalizedPath(RAILS_ROUTES.ABOUT, locale),
            },
            {
              title: t("vention.links.careers.title"),
              href: generateLocalizedPath(RAILS_ROUTES.CAREERS, locale),
            },
          ]}
        />
        <NavSubMenuSection
          heading={t("in_the_news.header")}
          items={[
            {
              title: t("in_the_news.links.press.title"),
              href: generateLocalizedPath(RAILS_ROUTES.PRESS, locale),
            },
            {
              title: t("in_the_news.links.events.title"),
              href: generateLocalizedPath(RAILS_ROUTES.EVENTS, locale),
            },
            {
              title: t("in_the_news.links.demo_day.title"),
              href: generateLocalizedPath(MARKETING_ROUTES.DEMO_DAY, locale),
            },
          ]}
        />
      </WrapperComponent>
    );
  }

  return (
    <WrapperComponent title={t("title")}>
      <Accordion type="multiple" className="w-full border-none">
        <MobileNavSubSection
          title={t("vention.header")}
          items={[
            {
              title: t("vention.links.mission.title"),
              href: generateLocalizedPath(RAILS_ROUTES.ABOUT, locale),
            },
            {
              title: t("vention.links.careers.title"),
              href: generateLocalizedPath(RAILS_ROUTES.CAREERS, locale),
            },
          ]}
        />
        <MobileNavSubSection
          title={t("in_the_news.header")}
          items={[
            {
              title: t("in_the_news.links.press.title"),
              href: generateLocalizedPath(RAILS_ROUTES.PRESS, locale),
            },
            {
              title: t("in_the_news.links.events.title"),
              href: generateLocalizedPath(RAILS_ROUTES.EVENTS, locale),
            },
            {
              title: t("in_the_news.links.demo_day.title"),
              href: generateLocalizedPath(MARKETING_ROUTES.DEMO_DAY, locale),
            },
          ]}
        />
      </Accordion>
    </WrapperComponent>
  );
};
